<template>
    <div class="mt-5">
        <h2>Vanlige spørsmål</h2>
        <br>
        <div class="container">
            <div class="accordion" role="tablist">
                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1 bg-white" role="tab">
                        <b-button block v-b-toggle.accordion-1
                                  class="d-flex justify-content-between align-items-center text-left bg-white border-0 text-dark">
                            <span>Gavekortet har gått ut på dato</span>
                            <span class="youwish-color">
                              {{ isAccordion1Open ? '-' : '+' }}
                            </span>
                        </b-button>
                    </b-card-header>
                    <b-collapse id="accordion-1" v-model="isAccordion1Open" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-card-text>
                                Betaling fra oss forutsetter vanligvis alltid at verdibeviset til kunden er gyldig og løses inn før utløpsdatoen, men ta kontakt med oss <a href="https://support.youwish.no/" target="">her</a>, så skal vi selvfølgelig se hva vi kan gjøre videre i akkurat ditt tilfelle.
                            </b-card-text>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1 bg-white" role="tab">
                        <b-button block v-b-toggle.accordion-2 variant="info"
                                  class="d-flex justify-content-between align-items-center text-left bg-white border-0 text-dark">
                            <span>Gavekort er løst inn og kunde vil bytte dato</span>
                            <span class="youwish-color">
                                {{ isAccordion2Open ? '-' : '+' }}
                            </span>
                        </b-button>
                    </b-card-header>
                    <b-collapse id="accordion-2" v-model="isAccordion2Open" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-card-text>
                                <p>Når gavekortet er løst inn, er det deres refunderings- og ombookingsregler som
                                    gjelder. Ønsker kunden å
                                    endre dato for gjennomføring, er dette en egen avtale mellom dere og kunden.</p>
                                <p>Vi anbefaler å sette en tydelig policy gjeldende ombooking for egne og YouWish sine
                                    kunder. Uten en
                                    tydelig betingelse er erfaring at kunder ombestemmer mer enn vanlig som skaper mye
                                    arbeid.</p>
                            </b-card-text>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1 bg-white" role="tab">
                        <b-button block v-b-toggle.accordion-3 variant="info"
                                  class="d-flex justify-content-between align-items-center text-left bg-white border-0 text-dark">
                            <span>Hvor mange gavekort har vi solgt?</span>
                            <span class="youwish-color">
                                {{ isAccordion3Open ? '-' : '+' }}
                            </span>
                        </b-button>
                    </b-card-header>
                    <b-collapse id="accordion-3" v-model="isAccordion3Open" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-card-text>
                                Vi har dessverre ikke noen oversikt over totalt antall gavekort som er solgt på hver
                                opplevelse da kundene våre
                                handler gavekort med en angrefrist på 14 dager, samt 365 dagers bytterett. Vi opplever
                                en del bytter hver dag
                                og garantien for gjennomføring kommer først når kundene tar direkte kontakt med dere for
                                booking.
                            </b-card-text>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1 bg-white" role="tab">
                        <b-button block v-b-toggle.accordion-4 variant="info"
                                  class="d-flex justify-content-between align-items-center text-left bg-white border-0 text-dark">
                            <span>Prisjustering</span>
                            <span class="youwish-color">
                                {{ isAccordion4Open ? '-' : '+' }}
                            </span>
                        </b-button>
                    </b-card-header>
                    <b-collapse id="accordion-4" v-model="isAccordion4Open" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-card-text>
                                Vi har prisgaranti - det eneste kravet er at vi tilbyr den samme prisen som dere.
                                <br/><br/>
                                Ta kontakt med YouWish Support <a href="https://support.youwish.no" target="_blank">her</a> og legg ved
                                navnet på opplevelsen/opplevelsene dere ønsker å endre prisen på. Merk: Prisen må være
                                endret i
                                deres kanaler før vi kan gjennomføre endringen hos oss.
                            </b-card-text>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1 bg-white" role="tab">
                        <b-button block v-b-toggle.accordion-5 variant="info"
                                  class="d-flex justify-content-between align-items-center text-left bg-white border-0 text-dark">
                            <span>Oppdatere informasjon</span>
                            <span class="youwish-color">
                              {{ isAccordion5Open ? '-' : '+' }}
                            </span>
                        </b-button>
                    </b-card-header>
                    <b-collapse id="accordion-5" v-model="isAccordion5Open" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-card-text>
                                Ta kontakt med YouWish Support <a href="https://support.youwish.no" target="_blank">her</a> og legg ved
                                navnet på opplevelsen/opplevelsene dere ønsker å legge inn endring på, samt ønsket
                                endring.
                                Merk at vi følger strenge retningslinjer for hva slags informasjon som kan presenteres
                                på produktsidene, hvor informasjon kan presenteres og eventuelt hvordan. Alle ønsker om
                                endringer må derfor vurderes av tekstforfatter i henhold til våre retningslinjer, og kan
                                kun oppfylles dersom de ikke bryter med disse.
                            </b-card-text>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1 bg-white" role="tab">
                        <b-button block v-b-toggle.accordion-6 variant="info"
                                  class="d-flex justify-content-between align-items-center text-left bg-white border-0 text-dark">
                            <span>Vi ønsker å legge ut flere opplevelser </span>
                            <span class="youwish-color">
                              {{ isAccordion6Open ? '-' : '+' }}
                            </span>
                        </b-button>
                    </b-card-header>
                    <b-collapse id="accordion-6" v-model="isAccordion6Open" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-card-text>
                                Ta kontakt med YouWish Support <a href="https://support.youwish.no" target="_blank">her</a> og legg ved navnet på
                                opplevelsen/opplevelsene dere ønsker å legge inn endring på, samt ønsket endring.
                            </b-card-text>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1 bg-white" role="tab">
                        <b-button block v-b-toggle.accordion-7 variant="info"
                                  class="d-flex justify-content-between align-items-center text-left bg-white border-0 text-dark">
                            <span>Endre juridiske opplysninger</span>
                            <span class="youwish-color">
                                {{ isAccordion7Open ? '-' : '+' }}
                            </span>
                        </b-button>
                    </b-card-header>
                    <b-collapse id="accordion-7" v-model="isAccordion7Open" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-card-text>
                                For å endre kontonummer eller andre juridiske endringer, ta kontakt med YouWish Support
                                <a href="https://support.youwish.no" target="_blank">her</a> og legg ved hvilke opplysninger dere ønsker å endre (juridisk
                                navn, org.nummer,
                                adresse).
                            </b-card-text>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1 bg-white" role="tab">
                        <b-button block v-b-toggle.accordion-8 variant="info"
                                  class="d-flex justify-content-between align-items-center text-left bg-white border-0 text-dark">
                            <span>Når får vi betalt?</span>
                            <span class="youwish-color">
                                {{ isAccordion8Open ? '-' : '+' }}
                            </span>
                        </b-button>
                    </b-card-header>
                    <b-collapse id="accordion-8" v-model="isAccordion8Open" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-card-text>
                                <p>Verdibevis som er lagt til oppgjør før den 01. blir utbetalt rundt den 15.</p>
                                <p>YouWish betaler løpende ut penger til dere for innløste verdibevis. Dere finner
                                    innløste
                                    verdibevis under menyvalget ”Oppgjør”. Hvert enkelt innløst verdibevis vil danne
                                    utbetalingsgrunnlaget.
                                    For å få betalt for innløste verdibevis må disse markeres og legges til neste måneds
                                    utbetaling.</p>
                                <p>Vi anbefaler å huke av på "Legg automatisk til oppgjør", så slipper dere å gå inn
                                    hver måned og huke
                                    av for å legge til oppgjør.</p>
                                <p>Bilag må lastes ned manuelt. Dette sendes ikke ut automatisk per i dag.</p>
                            </b-card-text>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1 bg-white" role="tab">
                        <b-button block v-b-toggle.accordion-9 variant="info"
                                  class="d-flex justify-content-between align-items-center text-left bg-white border-0 text-dark">
                            <span>Merverdiavgift</span>
                            <span class="youwish-color">
                                {{ isAccordion9Open ? '-' : '+' }}
                            </span>
                        </b-button>
                    </b-card-header>
                    <b-collapse id="accordion-9" v-model="isAccordion9Open" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-card-text>
                                <p>Vi fakturerer dere 25% mva, men siden dere er momsregistrert får dere tilbakebetalt summen når dere melder inn dette som vanlig.</p>
                                <p>Faktura fra YouWish.no går som formidlingstjeneste. Denne tjenesten er momspålagt og skal inn i regnskapet.</p>
                            </b-card-text>
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isAccordion1Open: true,
            isAccordion2Open: false,
            isAccordion3Open: false,
            isAccordion4Open: false,
            isAccordion5Open: false,
            isAccordion6Open: false,
            isAccordion7Open: false,
            isAccordion8Open: false,
            isAccordion9Open: false,
        }
    }
}
</script>

<style scoped>
.youwish-color {
    color: #17C27C;
}
</style>
